import { COLORS } from '@btime/constants'
import { formatDate } from '@btime/helpers'
import React from 'react'

import { Text } from '../../../../../../components/presentation/Text'
import { useTriggerCalls } from '../_load/TriggerCallsLoader'
import DataTable from '../../../../../../packages/kiti/components/table/DataTable'
import Tag from '../../../../../../components/presentation/Tag'
import { SmallText } from '../../../../../../packages/kiti/components/presentation/Text'
import Link from '../../../../../../components/actions/Link'
import TriggerSentence from '../../../../../../containers/triggers/TriggerSentence'
import { useOpenTriggerCallModal } from '../../../../../../utils/routes/modals/modalsActions'
import { useRetryTriggerCall } from '../_requests/retryTriggerCall'
import Icon from '../../../../../../packages/kiti/components/shapes/Icon'
import LoadingWrapper from '../../../../../../packages/kiti/components/helpers/LoadingWrapper'

const TriggerCallsTable = () => {
  const data = useTriggerCalls()
  const openDetailsModal = useOpenTriggerCallModal()
  const [retry, { loading }] = useRetryTriggerCall()

  const columns = [
    {
      label: `Nome `,
      dataIndex: 'data',
      sortIndex: false,
      flex: 4,
      render: (data, record) => (
        <Link onClick={() => openDetailsModal(record)}>
          <TriggerSentence trigger={data.trigger} />
        </Link>
      )
    },

    {
      label: 'Status',
      dataIndex: 'status',
      flex: 1,
      render: status => <Tag label={status} color={status === 'error' && COLORS.red} />
    },

    {
      label: 'Entidade de origem',
      dataIndex: 'data',
      format: data => data?.record?.name || data?.record?.yearly_id,
      flex: 1,
      render: (name, record) => (
        <>
          <SmallText size="xxsmall">{record.entityType}</SmallText>
          <Text>{name}</Text>
        </>
      )
    },

    {
      label: 'Entidade de destino',
      dataIndex: 'data',
      format: data => data?.result?.id,
      flex: 1,
      render: (id, record) => !!id && <Text>ID: {id}</Text>
    },

    {
      label: 'Data',
      dataIndex: 'updatedAt',
      format: formatDate('DD/MM/YYYY HH:mm'),
      flex: 1
    },

    {
      label: 'Executar novamente',
      dataIndex: 'id',
      flex: 1,

      render: (id, record) => (
        <LoadingWrapper loading={loading} size={1} type="spin">
          <Icon name="BsArrowRepeat" onClick={() => retry(id)} size={1} />
        </LoadingWrapper>
      )
    }
  ]

  return <DataTable rowKey="id" columns={columns} data={data} inPanel size="medium" />
}

export default TriggerCallsTable
